/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tl_Zoom_WeeksInputs */

const en_tl_zoom_weeks = /** @type {(inputs: Tl_Zoom_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weeks`)
};

const de_tl_zoom_weeks = /** @type {(inputs: Tl_Zoom_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wochen`)
};

/**
* | output |
* | --- |
* | "Weeks" |
*
* @param {Tl_Zoom_WeeksInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tl_zoom_weeks = /** @type {((inputs?: Tl_Zoom_WeeksInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tl_Zoom_WeeksInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_tl_zoom_weeks(inputs)
	return en_tl_zoom_weeks(inputs)
});